import merge from 'deepmerge';
import { Resource } from 'i18next';
import commonErrors from '../../common/translations/commonErrors';
import loginPage from './loginPage';
import errorPage from './errorPage';
import signInRedirectPage from './signInRedirectPage';
import navBar from './navBar';
import common from './common';

const translations = merge.all([common, errorPage, loginPage, signInRedirectPage, navBar, commonErrors]) as Resource;

export default translations;
